import state from '@/stores/timeline/state.js'
import mutations from '@/stores/timeline/mutations.js'
import actions from '@/stores/timeline/actions.js'

export default {
  state,
  mutations,
  actions
}
